{% block sw_system_config_content_card_field %}
    <sw-inherit-wrapper
            v-model:value="actualConfigData[currentSalesChannelId][element.name]"
            v-bind="getInheritWrapperBind(element)"
            :has-parent="isNotDefaultSalesChannel"
            :inherited-value="getInheritedValue(element)"
            :class="'sw-system-config--field-' + kebabCase(getElementBind(element).name)"
    >
        <template #content="props">
            <sw-form-field-renderer
                    v-bind="getElementBind(element, props)"
                    :key="props.isInheritField + props.isInherited"
                    :disabled="props.isInherited"
                    :value="props.currentValue"
                    @update:value="props.updateCurrentValue"
                    :actualConfigData="actualConfigData[currentSalesChannelId]"
                    :currentSalesChannelId="currentSalesChannelId"
            />
        </template>
    </sw-inherit-wrapper>
{% endblock %}